var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8125 4.93767C12.9602 4.78993 13.1356 4.67274 13.3287 4.59279C13.5217 4.51283 13.7286 4.47168 13.9375 4.47168C14.1464 4.47168 14.3533 4.51283 14.5463 4.59279C14.7394 4.67274 14.9148 4.78993 15.0625 4.93767C15.2102 5.08541 15.3274 5.2608 15.4074 5.45382C15.4873 5.64685 15.5285 5.85374 15.5285 6.06267C15.5285 6.2716 15.4873 6.47849 15.4074 6.67152C15.3274 6.86454 15.2102 7.03993 15.0625 7.18767L7.46875 14.7814L4.375 15.6252L5.21875 12.5314L12.8125 4.93767Z",
    stroke: "#8F90A6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.e1f997acc24214f448942064ded15da5.svg";
export { ForwardRef as ReactComponent };